import { Box, Typography } from "@mui/material";
import React from "react";

const Card = ({ Header = false, body = false, loading }) => {
  // if(loading){
  //   return  <Box bgcolor={'white'} display= mx='1.5em' borderRadius={'0.5em'} pt='1em' pb='1.5em' border={'1px solid #EDF0F2'}>
  //     <span className='dot-falling'></span>
  //   </Box>
  // }
  return (
    <Box
      bgcolor={"white"}
      mx="1.5em"
      borderRadius={"0.5em"}
      pt="1em"
      pb="1.5em"
      border={"1px solid #EDF0F2"}
    >
      <Typography
        fontSize={"10px"}
        lineHeight="16px"
        color={"success.dark"}
        mb="1em"
        textAlign="center"
      >
        {Header}
      </Typography>
      {loading ? (
        <Box display={'flex'} justifyContent='center' alignItems={'center'} my={'1em'}>
          <span className="dot-falling"></span>
        </Box>
      ) : (
        <>
          <Typography fontSize={"32px"} lineHeight="40px" textAlign="center">
            {body}
          </Typography>
        </>
      )}
    </Box>
  );
};

export default Card;
